// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-1XvB4";
var _4 = "header-21RPL";
var _5 = "content-3XQrC";
var _6 = "services-10Ir2";
var _7 = "services__item-2fG51";
var _8 = "barcode-1Dscs";
var _9 = "footer-2G_29";
var _a = "cancelModal-39oUk";
var _b = "barcode__direction-2RqHg";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "header", _5 as "content", _6 as "services", _7 as "services__item", _8 as "barcode", _9 as "footer", _a as "cancelModal", _b as "barcode__direction" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "header": _4, "content": _5, "services": _6, "services__item": _7, "barcode": _8, "footer": _9, "cancelModal": _a, "barcode__direction": _b }
